<template>
  <modal :show.sync="modalEdit">
    <h4 slot="header" class="title title-up">Editar Subcategoria</h4>
    <ValidationObserver ref="formEdit" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(editRow)">
        <div class="row">
           <el-select
             size="large"
             :placeholder="$t('app.modules.category_product.headers.category')"
          v-model="subcategory.idCategoriaProducto"
        >
          <el-option
            v-for="rol in categorias"
            class="select-primary"
            :value="rol.idCategoriaProducto"
            :label="rol.nombreCategoria"
            :key="rol.idCategoriaProducto"
          >
          </el-option>
        </el-select>
        </div>

        <div v-for="(lang) in subcategory.traducciones">
          <h6>{{ lang.idioma.idioma }}</h6>
          <div class="row">
            <div class="col-12">
              <fg-input
                type="text"
                name="minLength"
                :label="$t('app.modules.subcategory_product.headers.name')"
                v-model="lang.nombreSubcategoria"
              >
              </fg-input>
            </div>
          </div>
          <div class="separate"></div>
        </div>

        <div class="row">
          <div class="col-sm-6 form-group has-label">
            <div class="row">
              <label style="margin-left: 15px">{{ $t("app.modules.messages.headers.state") }}</label>
            </div>
            <template>
              <n-switch v-model="subcategory.activo">
                <i class="now-ui-icons ui-1_check" slot="on"></i>
                <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
              </n-switch>
            </template>
          </div>
        </div>
        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left btn-secondary" @click.native="cancelEdit"
            >{{ $t("app.buttons.cancel") }}</n-button
          >
          <n-button native-type="submit" type="primary">{{ $t("app.buttons.save") }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>
<script>
import { mapState } from "vuex";
import SubcategoriaProducto from "@/models/familiaProducto/SubcategoriaProducto";
import {getResponse} from "@/util/utilities";

export default {
  components: {},
  data() {
    return {
      categorias: [],
      subcategory: new SubcategoriaProducto(),
      switches: {
        withIconsOn: true
      },
      minLength: "",
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      modalEdit: false
    };
  },
  computed: {
    ...mapState(["user", "availableLangs"])
  },
  created() {
    this.subcategory.claveIdioma = this.$store.state.lang;
    this.getCategorias();
  },
  mounted() {
    EventBus.$on("subcategoriaproducto-edit",  item => {
      this.subcategory = item;
      this.subcategory.usuario = this.user.name;
      this.subcategory.usuarios_IdUsuario = this.user.idUsuario;

      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      this.$swal.close();
      this.modalEdit = true;
    });
  },
  methods: {
    cancelEdit() {
      this.modalEdit = false;
      this.$refs.formEdit.reset();
    },
    async editRow() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      }).then(null);

      try
      {
        this.subcategory.traducciones.forEach(t => {
          if(!t.nombreSubcategoria) throw new Error(this.$t('app.modules.category_product.errors.no_name') + ": " + t.idioma.idioma);
        });
        let request = await this.$http.put(route("Subcategoria/UpdateSubcategoria"), this.subcategory);
        let response = getResponse(request, null);

        if(response){
          this.notifyMessage("success", this.$t("app.promps.save_success"));
          EventBus.$emit("reload-items");
          this.cancelEdit();
        }
        else this.notifyMessage("danger", this.$t("app.promps.error"));
      }
      catch (e){
        this.notifyMessage('danger', e.message);
      }
      finally
      {
        this.$swal.close();
      }
    },
    async getCategorias(){
      let payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0,
        onlyActives: true
      };

      let request = await this.$http.post(route("CategoriaProducto/getCategoria"), payload);
      let response = getResponse(request, null);

      if(response != null){
        this.categorias = response.categoriaProducto

        if(this.categorias.length > 0){
          this.subcategory.idCategoriaProducto = this.categorias[0].idCategoriaProducto;
        }

      }
      else this.notifyMessage("danger", this.$t("app.promps.error"));
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0 2px 5px 0 #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
<style scoped>
.el-select--large {
  width: 100% !important;
}
</style>
